import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireComponentSchedule} from '@tisa-group/models';
import {CarouselModule} from '@tisa-group/client-ui/components/carousel';
import {MatchTileComponent} from './match-tile/match-tile.component';
import {SvgIconComponent} from '@tisa-group/client-ui/components/svg-icon';
import {RouterModule} from '@angular/router';
import {TISA_CURRENT_LOCALE} from '@tisa-group/client-ui/tokens';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'tisa-schedule',
  imports: [
    CommonModule,
    CarouselModule,
    MatchTileComponent,
    RouterModule,
    SvgIconComponent,
    TranslateModule,
  ],
  templateUrl: './schedule.component.html',
  styleUrl: './schedule.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScheduleComponent {
  readonly component = input<UmpireComponentSchedule | undefined>();

  readonly matches = computed(() => this.component()?.matches || []);

  readonly locale = inject(TISA_CURRENT_LOCALE);

  buttonRightDisabled = signal(false);

  buttonLeftDisabled = signal(true);

  onButtonRightStatusChanges(disabled: boolean) {
    this.buttonRightDisabled.set(disabled);
  }

  onButtonLeftStatusChanges(disabled: boolean) {
    this.buttonLeftDisabled.set(disabled);
  }
}
